var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticClass: "px-1 mt-1", attrs: { flat: "" } },
    [
      _c("v-card-text", { staticClass: "pa-0" }, [
        _c(
          "h3",
          { staticClass: "pa-1 pl-2" },
          [
            _vm._v(_vm._s(_vm.$t("message.projects.project")) + ": "),
            _c("router-link", { attrs: { to: "/projects/" + _vm.projectId } }, [
              _vm._v(_vm._s(_vm.projectFullName)),
            ]),
          ],
          1
        ),
      ]),
      _c("compact-list", { key: _vm.reInit, attrs: { payload: _vm.payload } }),
      _c("div", { ref: "lgContainer", staticStyle: { display: "none" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }